import React, { useCallback, useEffect, useState } from 'react';
import { Box, Chip, Collapse, List, ListItem, Typography, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { OKRButton } from '../../Common/OKRButton';
import { AddIconSvg, DeleteIcon } from '../../../config/svg/CommonSvgIcon';
import '../../../styles/pages/okr-listing/okr-listing.scss';
import { RightArrowIcon } from '../../../config/svg/ArrowSvg';
import { useDispatch, useSelector } from 'react-redux';
import { publishObjective, refreshAdminDefaultOkrList } from '../../../action/adminDefaultOkr';
import { createUUID, formatDate, getOkrProgressDetails, getUserDetails } from '../../../config/utils';
import { Enums } from '../../../config/enums';
import AlertDialog from '../../Common/Dialog';
import { DialogComponent } from '../../Admin/CommonComponent/DialogComponent';
import {
	createDefaultKpi,
	deleteUserKpi,
	getKpiProgress,
	highlightKpi,
	setKpiListReload,
	setShowKpiCreateOpen,
} from '../../../action/MyKpis';
import { KpiActions } from './KpiActions';
import { KpiProgressBarMain } from '../MyProgress/KpiProgressBarMain';
import { getLocalStorageItem } from '../../../services/StorageService';
import { updateKrProgressValue } from '../../../action/myGoal';
import AddNewKpiKr from './AddNewKpiKr';
import { useSnackbar } from 'notistack';
import { KpiTextEdit } from './KpiTextEdit';

export const keyDetailObject = {
	id: createUUID(),
	goalKeyId: Enums.ZERO,
	keyDescription: '',
	keyNotes: '',
	score: Enums.ZERO,
	startDate: formatDate(new Date()),
	dueDate: formatDate(getLocalStorageItem('currentCycleEndDate') || null),
	employeeId: 0,
	startValue: 0,
	targetValue: 0,
	currentValue: 0,
	metricId: 0,
	isDefaultGoalKey: false,
	defaultGoalKeyId: 0,
	currencyId: 3,
	currencyCode: '',
	goalStatusId: 1,
	kpiCategoryMasterId: 0,
};
export const UserKpisKrList: React.FC<any> = (props: any) => {
	const {
		selectedCycleDetails,
		setShowLoader,
		showLoader,
		defaultOkrAPICall,
		listingData,
		setListingData,
		objData,
		handleExpandKeyResult,
		expandedKrList,
		handleListAction,
		updateName,
		updateTextValue,
		handleClickInputAway,
		showEditLoader,
		getEmployeeId,
		isAllowToSendApproval,
		getKpiUser,
		kpiDataList,
	} = props;
	const { t } = useTranslation();
	const userDetail: any = getUserDetails();
	const dispatch = useDispatch();
	const { okrMasterData } = useSelector((state: any) => state.okrReducer);
	const { highlightedId } = useSelector((state: any) => state.kpiReducer);

	const [modalProps, setModalProps] = useState<any>({ open: false, message: '', details: '' });
	const [modalOpen, setModalOpen] = useState(false);
	const [publishDisabled, setPublishDisabled] = useState(false);
	const [modalPerformanceProps, setModalPerformanceProps] = useState<any>({ open: false, message: '', details: '' });

	const [newKeyList, setNewKeyList] = useState<any>([]);
	const [isAddClicked, setIsAddClicked] = useState<boolean>(false);
	const [finalSubmitted, setFinalSubmitted] = useState<boolean>(false);
	const loggedInUserDetail = getUserDetails();

	const showApiMsgs = (msg: string, variant: any) => {
		enqueueSnackbar(msg, {
			variant: variant,
			autoHideDuration: 5000,
		});
	};
	const handlePublishOkr = async () => {
		setPublishDisabled(true);
		const response: any = await dispatch(
			publishObjective({
				objectiveCycleId: selectedCycleDetails?.organisationCycleId,
				objectiveId: 0,
				loginUserId: 0,
			})
		);
		if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
			dispatch(refreshAdminDefaultOkrList(true));
			setPublishDisabled(false);
		} else {
		}
	};
	const handleCloseAlertModal = (e: React.ChangeEvent<HTMLInputElement>, type: number) => {
		e.preventDefault();

		if (type === 1) {
			handlePublishOkr();
			setModalOpen(false);
		} else {
			setModalOpen(false);
		}
	};

	const updateProgress = async (
		goalKeyId: number,
		assignmentTypeId: number,
		value: number,
		year: number,
		okr?: any,
		confidenceValue = 0
	) => {
		const cycleId =
			selectedCycleDetails && selectedCycleDetails?.organisationCycleId ? selectedCycleDetails?.organisationCycleId : 0;
		const selectedYear = getLocalStorageItem('year') || year;
		const data: any = { goalKeyId: goalKeyId, currentValue: value, year: selectedYear };

		const resp: any = await dispatch(updateKrProgressValue(data));
		if (resp && resp.data.status === Enums.STATUS_SUCCESS) {
			const respData = resp?.data?.entity;
			const { currentValue, okrScore, targetValue, actualValue, realScore, overallScore } = respData;
			let newScore = 0;
			if (respData?.score) {
				newScore = respData.score < 0 ? 0 : respData.score > 100 ? 100 : respData.score;
			}
			//==== update Progress
			let goalData = { goalObjectiveId: 0, myGoalsDetails: [] };
			let updatedList = [];
			if (assignmentTypeId === 1) {
				updatedList = listingData.map((item: any) => {
					if (item.goalKeyId === goalKeyId) {
						goalData = item;
						if (confidenceValue) {
							item.confidenceId = confidenceValue;
						}
						item.currentValue = value;
						item.actualValue = actualValue;
						item.isScored = true;
						item.krStatusId = Enums.KR_STATUS_ACCEPTED;
						item.keyProgressTime = Boolean(respData.updatedOn) ? respData.updatedOn : item.keyProgressTime;
						item.score = newScore;
						item.myScore = newScore;
						item.realScore = realScore;
						item.overallScore = overallScore;
					}
					return item;
				});
			} else {
				const updatedKrList = listingData.map((item: any) => {
					item.myGoalsDetails = item.myGoalsDetails.map((keys: any) => {
						if (keys.goalKeyId === goalKeyId) {
							goalData = item;
							keys.isKrAchieved = targetValue === currentValue || currentValue > targetValue ? true : false;
							keys.currentValue = value;
							keys.actualValue = actualValue;
							keys.isScored = true;
							item.krStatusId = Enums.KR_STATUS_ACCEPTED;
							keys.keyProgressTime = Boolean(respData.updatedOn) ? respData.updatedOn : keys.keyProgressTime;
							keys.score = newScore;
							keys.myScore = newScore;
							keys.realScore = realScore;
							keys.overallScore = overallScore;
						}

						return keys;
					});
					return item;
				});
				const progressionScore = okrScore;

				updatedList = updatedKrList.map((item: any) => {
					if (item.goalObjectiveId === goalData.goalObjectiveId) {
						item.score = Math.round(progressionScore);
						let { okrProgress } = getOkrProgressDetails({
							value: item.score,
							dueDate: item.dueDate,
						});
						item.okrScore = okrScore;
						item.okrProgress = okrProgress;
						item.goalProgressTime = Boolean(respData.updatedOn) ? respData.updatedOn : item.goalProgressTime;
					}
					return item;
				});
			}

			setListingData(updatedList);

			//const data = `empId=${getEmployeeId()}&cycle=${cycleId}&year=${selectedYear}`;
			const data = `empId=${getEmployeeId()}&cycle=${cycleId}`;
			dispatch(getKpiProgress(data, true));
		} else {
		}
	};

	const setObjData = async (goalData: any) => {
		const updatedList = listingData.map((item: any) => {
			if (item.goalObjectiveId === goalData.goalObjectiveId) {
				return goalData;
			}
			return item;
		});

		setListingData(updatedList);
	};

	const deleteDefaultKpiCategory = async (okrDetails: any) => {
		try {
			if (okrDetails?.goalObjectiveId) {
				setShowLoader(true);
				const requestParams = `goalId=${okrDetails?.goalObjectiveId}&goalType=1`;
				const response: any = await dispatch(deleteUserKpi(requestParams));
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					defaultOkrAPICall(false);
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					showApiMsgs('error', messages || 'Error occurred while fetching default okr details');
					setShowLoader(false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleDeleteKpiCategoryClick = (event: any, okrDetails: any) => {
		try {
			if (okrDetails?.status === Enums.ONE) {
				let msg = '';
				if (okrDetails?.myGoalsDetails?.length === Enums.ZERO) {
					msg = t('deleteKpiCategoryMessage');
				} else if (okrDetails?.myGoalsDetails?.length) {
					msg = t('deleteListingKpiCatMessage');
				}
				setModalPerformanceProps({
					open: true,
					message: msg,
					details: { okrDetails: okrDetails, deleteType: 'DefaultOKR' },
					event: event,
				});
			} else {
				setModalProps({
					open: true,
					message: '',
					details: {
						okrDetails: okrDetails,
						deleteType: 'DefaultOKR',
						headingText: t('deleteListingKpiCatMessage'),
						subHeading: '',
						matchString: Enums.DELETE_TEXT,
					},
				});
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handlePerformanceCloseModal = async (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			const { details } = modalPerformanceProps || {};
			if (details && details?.deleteType === 'DefaultOKR') {
				const okrDetails = details?.okrDetails || null;
				if (okrDetails) {
					deleteDefaultKpiCategory(okrDetails);
				}
			}

			setModalPerformanceProps({ open: false, message: '', details: '' });
		} else {
			setModalPerformanceProps({ open: false, message: '', details: '' });
		}
	};
	const handleConfirmationCloseModal = async (e: any, type: any) => {
		try {
			if (type === 1) {
				const { details } = modalProps || {};
				if (details && details?.deleteType === 'DefaultOKR') {
					const okrDetails = details?.okrDetails || null;
					if (okrDetails) {
						deleteDefaultKpiCategory(okrDetails);
					}
				}
				setModalProps({ open: false, message: '', details: '' });
			} else {
				setModalProps({ open: false, message: '', details: '' });
			}
		} catch (error) {
			console.error(error);
		}
	};

	const addNewKeyResult = (e: any, okr: any) => {
		setFinalSubmitted(false);
		//handleUserClickOnCard(e);
		setIsAddClicked(true);
		const contData = {
			employeeId: getEmployeeId(),
			goalStatusId: okr.status,
			kpiType: getEmployeeId() === userDetail.employeeId ? 3 : 2,
			objectiveName: okr.objectiveName,
			fullName: userDetail.fullName,
			firstName: userDetail.firstName,
			lastName: userDetail.lastName,
			emailId: userDetail.emailId,
			designation: userDetail.designation,
			imagePath: userDetail.imagePath,
			cycleId: props.userSelectedCycle?.organisationCycleId || 0,
			year: props.userSelectedCycle?.year,
			goalId: okr.goalObjectiveId,
		};
		setNewKeyList([
			...newKeyList,
			{
				...keyDetailObject,
				...contData,
				id: createUUID(),
				isEditable: true,
				startDate: selectedCycleDetails?.defaultStartDate || selectedCycleDetails?.startDate,
				endDate: selectedCycleDetails?.defaultEndDate || selectedCycleDetails?.endDate,
				dueDate: selectedCycleDetails?.defaultEndDate || selectedCycleDetails?.endDate,
				isNewKey: false,
				owner: getEmployeeId(),
			},
		]);
	};

	const handleNewKeyResultChange = useCallback((value: any, key: any, item: any) => {
		if (key.trim()) {
			setNewKeyList((prevList: any) => {
				const list = [...prevList];
				const index = list.findIndex((ele: any) => ele.id === item.id);
				list[index][key] = value;
				return list;
			});
		}
	}, []);
	const { enqueueSnackbar } = useSnackbar();

	const validateDraftForm = (myGoalsDetails: any[]) => {
		let updatedErrorMessage = myGoalsDetails && myGoalsDetails?.length ? [...myGoalsDetails] : [];
		let isErrorUpdate: boolean = false;
		updatedErrorMessage = updatedErrorMessage.map((it: any) => {
			let data = { ...it };
			if (!data?.keyDescription || data?.keyDescription?.trim() === '') {
				isErrorUpdate = true;
				data = { ...data, isExpand: true, isKrNameError: true, krNameErrorMsg: t('addKpiTitle') };
			} else {
				data = { ...data, isKrNameError: false, krNameErrorMsg: '' };
			}
			if (!data.metricId) {
				isErrorUpdate = true;
				data = {
					...data,
					isExpand: true,
					isMetricTypeError: true,
					krMetricTypeErrorMsg: t('metricTypeRequired'),
					isMetricCurrencyError: false,
					krMetricCurrencyErrorMsg: '',
				};
			} else if (data.metricId === Enums.TWO && !data?.currencyId) {
				isErrorUpdate = true;
				data = {
					...data,
					isExpand: true,
					isMetricTypeError: false,
					krMetricTypeErrorMsg: '',
					isMetricCurrencyError: true,
					krMetricCurrencyErrorMsg: t('currencyRequired'),
				};
			}
			if (data?.isTargetSame && !data.targetValue && !data.startValue) {
				isErrorUpdate = true;
				data = {
					...data,
					isExpand: true,
					isTargetValueError: true,
					krTargetValueErrorMsg: t('targetValueRequired'),
				};
			} else if (data?.isTargetSame && data.targetValue === data.startValue) {
				isErrorUpdate = true;

				data = {
					...data,
					isExpand: true,
					isTargetValueError: true,
					krTargetValueErrorMsg: t('startTargetNotSame'),
				};
			} else {
				data = { ...data, isTargetValueError: false, krTargetValueErrorMsg: '' };
			}

			return data;
		});

		return { isErrorUpdate: !isErrorUpdate, data: updatedErrorMessage };
	};
	const handlePublishDefaultOkrClick = async (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
			let okrListValidate: any = validateDraftForm(objData.myGoalsDetails);
			let okrNewListValidate: any = validateDraftForm(newKeyList);
			if (okrListValidate.isErrorUpdate && okrNewListValidate.isErrorUpdate) {
				setShowLoader(true);
				const requestPayload = {
					...objData,
					status: Enums.TWO,
					kpiType: getEmployeeId() === userDetail.employeeId ? 3 : 2,
					myGoalsDetails: [...okrNewListValidate.data],
				};
				// Need to check KR Status based on isKrEdited flag
				delete requestPayload.selectedListDetails;
				let response: any = await dispatch(createDefaultKpi([requestPayload]));
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					setShowLoader(false);
					setNewKeyList([]);
					showApiMsgs(response?.data?.messageList.Result, 'success');
					dispatch(setKpiListReload(true));
					dispatch(setShowKpiCreateOpen(false));
				} else {
					setShowLoader(false);
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					enqueueSnackbar(messages || t('savingDraftError'), {
						variant: 'error',
						autoHideDuration: 3000,
					});
				}
				setShowLoader(false);
			} else {
				setObjData({ ...objData, myGoalsDetails: okrListValidate.data });
				setNewKeyList([...okrNewListValidate.data]);
			}
		} catch (error) {
			console.error(error);
			enqueueSnackbar(t('savingDraftError'), {
				variant: 'error',
				autoHideDuration: 3000,
			});
			setShowLoader(false);
		}
	};
	return (
		<>
			<Box
				className={`okr-listing-wrapper ${
					highlightedId?.kpiId === objData?.goalObjectiveId ? 'highlight-default-row highlighted-okr' : ''
				}`}
				id={`kpi_list_item_index_${objData?.goalObjectiveId}`}
			>
				<Box className='okr-listing-wrapper-inner'>
					<Box className='okr-head'>
						<List disablePadding component='ul'>
							<ListItem className='okr-col1 okr-drag-wrap'>
								<Box className='okr-col1-left'>
									<Box className='okr-objective'>
										<Box className='okr-after-edit'>
											{/* <Tooltip arrow title={objData.objectiveName || ''}> */}
											<Typography variant='h4'>{objData.objectiveName || ''}</Typography>
											{/* </Tooltip> */}
										</Box>
									</Box>
									<Box className={`okr-keys card-toggle`}>
										<OKRButton
											className={`btn-blue-chip ${
												expandedKrList.indexOf(objData.goalObjectiveId) !== -1 ? 'expand' : 'collapse'
											}`}
											icon={<RightArrowIcon />}
											text={objData.myGoalsDetails.length + ' KPI(s)'}
											id={`kr-toggle-btn-${objData.goalObjectiveId}`}
											handleClick={(e) => handleExpandKeyResult(e, objData)}
										/>
										{/* {objData.isEditable && (
											<Box className='okr-field-actions'>
												<OKRButton
													className='delete-btn'
													id='obj-delete-btn'
													icon={<DeleteIcon />}
													title={t('delete')}
													handleClick={(e: any) => handleDeleteKpiCategoryClick(e, objData)}
												/>
											</Box>
										)} */}
									</Box>
								</Box>
							</ListItem>
						</List>
					</Box>
					<Collapse
						className='okr-keys-listing'
						in={expandedKrList.indexOf(objData.goalObjectiveId) !== -1}
						timeout='auto'
						unmountOnExit
					>
						{objData.myGoalsDetails.map((keyData: any, keyIndex: number) => (
							<Box
								className={`okr-listing-wrapper kr-listing-content ${
									highlightedId?.kpiKrId === keyData?.goalKeyId ? 'show-highlighted' : ''
								}`}
							>
								<Box className={`okr-listing-wrapper-inner`}>
									<List component='ul'>
										<ListItem className='okr-col1 okr-drag-wrap'>
											<Box className='okr-col1-left'>
												<Box className='okr-objective kpi-text-field'>
													<Box
														onClick={(e) => {
															e.stopPropagation();
														}}
													>
														{keyData.isInlineEditingAllowed ? (
															!keyData.edit ? (
																<Box
																	id={`kr-name-${keyData?.goalKeyId}`}
																	className='okr-after-edit'
																	onClick={(e: any) => {
																		handleListAction(e, objData, keyData, 2);
																	}}
																>
																	<Tooltip arrow title={keyData.keyDescription || ''}>
																		<Typography variant='h4'>{keyData.keyDescription || ''}</Typography>
																	</Tooltip>
																</Box>
															) : (
																<KpiTextEdit
																	updateName={updateName}
																	updateTextValue={updateTextValue}
																	handleClickInputAway={(e: any) => {
																		handleListAction(e, objData, keyData, 2, false);
																	}}
																	showEditLoader={showEditLoader}
																	okr={objData}
																	kr={keyData}
																	goalType={2}
																/>
															)
														) : (
															<Box id={`kr-name-${keyData?.goalKeyId}`} className='okr-after-edit'>
																<Tooltip arrow title={keyData.keyDescription || ''}>
																	<Typography variant='h4'>{keyData.keyDescription || ''}</Typography>
																</Tooltip>
															</Box>
														)}
													</Box>
												</Box>
												<Box className={`okr-keys card-toggle`}>
													<Box className='kpi-status-info'>
														{keyData.kpiType === 1 && (
															<Chip className='organization-chip' label={keyData.kpiTypeName} />
														)}
														{keyData.kpiType === 2 && <Chip className='manager-chip' label={keyData.kpiTypeName} />}
														{keyData.kpiType === 3 && <Chip className='self-chip' label={keyData.kpiTypeName} />}
														{keyData?.krStatusIdName === 'Pending' ? (
															<Chip className='lagging-chip' label={keyData?.krStatusIdName} />
														) : (
															<></>
														)}
														{keyData?.krStatusIdName === 'Approved' ? (
															<Chip className='on-track-chip' label={keyData?.krStatusIdName} />
														) : (
															<></>
														)}
														{keyData.krStatusId === 3 && keyData?.krStatusIdName ? (
															<Chip className='at-risk-chip' label={keyData?.krStatusIdName} />
														) : (
															<></>
														)}
														{keyData?.krStatusIdName === 'Draft' ? (
															<Chip className='draft-chip' label={keyData?.krStatusIdName} />
														) : (
															<></>
														)}
													</Box>
													<KpiActions
														keyDetails={keyData}
														krIndex={keyIndex}
														showLoader={showLoader}
														setShowLoader={setShowLoader}
														mode={'Edit'}
														isAllowToSendApproval={isAllowToSendApproval}
														defaultOkrFormDetails={{}}
														setDefaultOkrFormDetails={() => {}}
													/>
												</Box>
											</Box>
										</ListItem>
										<ListItem className='okr-col2'>
											<KpiProgressBarMain
												{...props}
												loginUserAvatar={{
													...keyData,
													goalStatusId: 2,
													krId: keyData.goalKeyId,
													goalKeyId: keyData.goalKeyId,
												}}
												parentOkr={{ ...objData, goalStatusId: 2 }}
												okr={{
													...keyData,
													goalStatusId: 2,
													krId: keyData.goalKeyId,
													goalKeyId: objData.goalObjectiveId,
												}}
												kr={{
													...keyData,
													goalStatusId: 2,
													krId: keyData.goalKeyId,
													goalKeyId: keyData.goalKeyId,
												}}
												type={'kr'}
												t={t}
												updateProgress={updateProgress}
												showEditLoader={false}
												currentUser={userDetail}
												kpiUser={getKpiUser()}
												okrMasterData={okrMasterData}
												showArchiveList={false}
												isScoreLocked={false}
												enqueueSnackbar={() => {}}
												isAnyDrawerOpened={false}
												appDrawerInfo={props.appDrawerInfo}
												setOpenKrId={() => {}}
												setErrorOpen={() => {}}
												errorOpen={false}
												isEditable={keyData.krStatusId === 2 && loggedInUserDetail.employeeId === keyData.employeeId}
												kpiDataList={kpiDataList}
											/>
										</ListItem>
									</List>
								</Box>
							</Box>
						))}
						<AddNewKpiKr
							okrMasterData={okrMasterData}
							objData={objData}
							newKeyList={newKeyList}
							setNewKeyList={setNewKeyList}
							userDetail={userDetail}
							updateProgress={updateProgress}
							t={t}
							showLoader={showLoader}
							setShowLoader={setShowLoader}
							handleNewKeyResultChange={handleNewKeyResultChange}
						/>
						<Box className='key-result-action'>
							<OKRButton
								className='btn-add-key'
								handleClick={(e: any) => {
									addNewKeyResult(e, objData);
								}}
								icon={<AddIconSvg />}
								text={t('addKpi')}
								id={`add-key-btn-${objData.goalObjectiveId}`}
							/>
						</Box>
						{newKeyList && newKeyList.length > 0 && (
							<Box className='drafted-okr-actions'>
								{/*<OKRButton
									className='btn-link draft-btn'
									text={t('saveAsDraft')}
									id={`save-draft-btn-kpiid`}
									//disabled={isDataSaving}
								/>
								<Typography>{t('orLabel')}</Typography>*/}
								<OKRButton
									className='btn-primary'
									text={t('submitKpi')}
									id={`save-draft-btn-kpiid`}
									handleClick={handlePublishDefaultOkrClick}
								/>
							</Box>
						)}
					</Collapse>
				</Box>
			</Box>
			{modalProps && modalProps.open && (
				<DialogComponent
					module='confirmation'
					modalOpen={modalProps.open}
					handleCloseModal={(e: any) => handleConfirmationCloseModal(e, 2)}
					matchString={modalProps?.details?.matchString || Enums.DELETE_TEXT}
					handleConfirmClick={(e: any) => handleConfirmationCloseModal(e, 1)}
					headingText={modalProps?.details?.headingText || ''}
					subHeading={modalProps?.details?.subHeading || ''}
				/>
			)}
			{modalOpen && (
				<DialogComponent
					module='information'
					message={t('publishText')}
					handleCloseModal={handleCloseAlertModal}
					modalOpen={modalOpen}
				/>
			)}
			{modalPerformanceProps && modalPerformanceProps.open && (
				<AlertDialog
					module='PerformanceReviewList'
					isCancel={false}
					message={modalPerformanceProps?.message || ''}
					handleCloseModal={handlePerformanceCloseModal}
					modalOpen={modalPerformanceProps.open}
				/>
			)}
		</>
	);
};
